// src/components/TokenDetailModal.js
import React, { useEffect } from 'react';
import { CARD_INFO } from './Card';
import './TokenDetailModal.css';

// 奖励代币信息（Card.js中没有）
const BONUS_INFO = {
  bonus_3: { name: '3张奖励', emoji: '🏆' },
  bonus_4: { name: '4张奖励', emoji: '🏆' },
  bonus_5: { name: '5张奖励', emoji: '🏆' }
};

function TokenDetailModal({ tokens, isOpen, onClose }) {
  // 分类代币
  const categorizeTokens = () => {
    const goodsTypes = ['diamond', 'gold', 'silver', 'cloth', 'spice', 'leather'];
    const bonusTypes = ['bonus_3', 'bonus_4', 'bonus_5'];

    const goods = tokens.filter(t => goodsTypes.includes(t.type));
    const bonus = tokens.filter(t => bonusTypes.includes(t.type));

    return { goods, bonus };
  };

  // 排序代币
  const sortTokens = (tokenList, category) => {
    const order = category === 'goods'
      ? ['diamond', 'gold', 'silver', 'cloth', 'spice', 'leather']
      : ['bonus_5', 'bonus_4', 'bonus_3'];

    return [...tokenList].sort((a, b) =>
      order.indexOf(a.type) - order.indexOf(b.type)
    );
  };

  // ESC键关闭 + 防止背景滚动
  useEffect(() => {
    if (isOpen) {
      const handleEsc = (e) => e.key === 'Escape' && onClose();
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';

      return () => {
        document.removeEventListener('keydown', handleEsc);
        document.body.style.overflow = '';
      };
    }
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const { goods, bonus } = categorizeTokens();
  const sortedGoods = sortTokens(goods, 'goods');
  const sortedBonus = sortTokens(bonus, 'bonus');

  return (
    <div className="token-modal-overlay" onClick={onClose}>
      <div className="token-modal-card" onClick={(e) => e.stopPropagation()}>
        <div className="token-modal-header">
          <h2>我的代币</h2>
          <button className="btn-close" onClick={onClose}>✕</button>
        </div>

        {/* 货物代币 */}
        {sortedGoods.length > 0 && (
          <div className="token-category">
            <h3>货物代币 ({sortedGoods.length})</h3>
            <div className="token-grid">
              {sortedGoods.map((token, idx) => {
                const info = CARD_INFO[token.type];
                return (
                  <div key={idx} className="token-card">
                    <div className="token-emoji">{info.emoji}</div>
                    <div className="token-name">{info.name}</div>
                    <div className="token-value">分值: {token.value}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* 奖励代币 */}
        {sortedBonus.length > 0 && (
          <div className="token-category">
            <h3>奖励代币 ({sortedBonus.length})</h3>
            <div className="token-grid">
              {sortedBonus.map((token, idx) => {
                const info = BONUS_INFO[token.type];
                return (
                  <div key={idx} className="token-card bonus">
                    <div className="token-emoji">{info.emoji}</div>
                    <div className="token-name">{info.name}</div>
                    <div className="token-value">分值: {token.value}</div>
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {/* 空状态 */}
        {tokens.length === 0 && (
          <div className="empty-tokens">暂无代币</div>
        )}
      </div>
    </div>
  );
}

export default TokenDetailModal;
